import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AppErrorBoundary"] */ "/vercel/path0/src/components/AppErrorBoundary/AppErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path0/src/components/ClientWrapper/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeferredPublicWidgets"] */ "/vercel/path0/src/components/DeferredPublicWidgets/DeferredPublicWidgets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GenerateDictionariesModal"] */ "/vercel/path0/src/components/GenerateDictionnariesButton/GenerateDictionnariesButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NeumoHeader"] */ "/vercel/path0/src/components/Headers/NeumoHeader/NeumoHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaPixel"] */ "/vercel/path0/src/components/MetaPixel/MetaPixel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClassicFooter"] */ "/vercel/path0/src/components/SliceMachine/ClassicComponents/ClassicFooter/ClassicFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StaticHeader"] */ "/vercel/path0/src/components/SliceMachine/ClassicComponents/StaticHeader/StaticHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/dictionaries/dictionary-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/vercel/path0/theme.ts");
